import React from 'react';
import { Container, Card, Center } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { ArrowRightIcon, ArrowDownIcon } from '@fiverr-private/visuals';
import { theme } from '@fiverr-private/theme';
import { AppI18n } from '../../../../i18n';
import { HowItWorksStepKey } from '../../../types/howItWorksSteps';

interface Props {
    icon: JSX.Element;
    stepKey: HowItWorksStepKey;
    hideArrow: boolean;
}

export const StepItem = ({ icon, stepKey, hideArrow }: Props) => (
    <Card
        display="flex"
        direction="column"
        alignItems="center"
        textAlign="center"
        background="white"
        borderColor="transparent"
        dropShadow="z1"
        position="relative"
        gap="2"
        borderRadius="lg"
        style={{
            padding: `${theme.spacing['9']} ${theme.spacing['6']}`,
        }}
    >
        <Center display="flex" alignContent="center" flexShrink="1" width="32px" height="33px">
            {icon}
        </Center>
        <Container flex="1">
            <Heading as="h5">
                <AppI18n k={`how_it_works.steps.${stepKey}.title`} />
            </Heading>
            <Text color="bodySecondary" size="b_md" maxWidth="284px">
                <AppI18n k={`how_it_works.steps.${stepKey}.description`} />
            </Text>
        </Container>
        <Container
            hidden={{ default: true, md: hideArrow }}
            position="absolute"
            top="50%"
            transform="translateY(-50%)"
            right="-38px"
        >
            <ArrowRightIcon />
        </Container>
        <Container
            hidden={{ default: hideArrow, md: true }}
            position="absolute"
            bottom="-38px"
            left="50%"
            transform="translateX(-50%)"
        >
            <ArrowDownIcon />
        </Container>
    </Card>
);
